import { render, staticRenderFns } from "./merchant_withdrawal.vue?vue&type=template&id=5c828e89&scoped=true&"
import script from "./merchant_withdrawal.vue?vue&type=script&lang=js&"
export * from "./merchant_withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./merchant_withdrawal.vue?vue&type=style&index=0&id=5c828e89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c828e89",
  null
  
)

export default component.exports